import { $api } from '../api'

import {
  IOrder,
  IOrderStatus,
  IOrdersDashboardSummaryQuery,
  IPagination,
  IStatistic,
} from 'dto/orders.dto'
import {
  buildAdminOrdersListParams,
  IAdminOrdersListQuery,
} from 'handlers/buildAdminOrdersListParams'
import { buildOrdersDashboardSummaryParams } from 'handlers/buildOrdersDashboardSummaryParams'

export default class OrderService {
  /**
   * Последний заказ в scope админа — для fallback poll уведомлений.
   * @param pizzeriaId — опциональный фильтр пиццерии
   */
  static async getAdminOrdersLatest(
    pizzeriaId?: number | null
  ): Promise<{
    latestId: number | null
    latestCreateAt: string | null
    latestTotalPrice: number | null
  }> {
    const params =
      typeof pizzeriaId === 'number' && !Number.isNaN(pizzeriaId)
        ? { pizzeria_id: pizzeriaId }
        : undefined
    const response = await $api.get(`/orders/admin-latest`, { params })
    const payload = response?.data
    return {
      latestId:
        typeof payload?.latestId === 'number' ? payload.latestId : null,
      latestCreateAt:
        typeof payload?.latestCreateAt === 'string'
          ? payload.latestCreateAt
          : null,
      latestTotalPrice:
        typeof payload?.latestTotalPrice === 'number'
          ? payload.latestTotalPrice
          : null,
    }
  }

  /**
   * Серверный список заказов с фильтрами и пагинацией.
   * @param query — параметры списка
   */
  static async getAdminOrdersList(
    query?: IAdminOrdersListQuery
  ): Promise<{ data: IOrder[]; total: number }> {
    const params = buildAdminOrdersListParams(query)
    const response = await $api.get(`/orders/admin-list`, { params })
    const payload = response?.data
    if (Array.isArray(payload)) {
      return { data: payload, total: payload.length }
    }
    return {
      data: Array.isArray(payload?.data) ? payload.data : [],
      total: typeof payload?.total === 'number' ? payload.total : 0,
    }
  }

  /**
   * @deprecated используйте getAdminOrdersList
   */
  static async getAllOrders(
    pagination?: IPagination
  ): Promise<{ data: IOrder[] }> {
    const response = await this.getAdminOrdersList({
      limit: pagination?.rowsPerPage ?? 20,
      offset: pagination
        ? pagination.page * pagination.rowsPerPage
        : 0,
    })
    return { data: response.data }
  }

  /**
   * Сводка для блока статистики на главной (расчёты на бэкенде).
   * @param query — фильтры пиццерии / статуса / оплаты
   */
  static async getDashboardSummary(
    query?: IOrdersDashboardSummaryQuery
  ): Promise<{ data: IStatistic }> {
    const params = buildOrdersDashboardSummaryParams(query)
    return $api.get(`/orders/dashboard-summary${params}`)
  }

  /**
   * Карточка заказа для страницы деталей (отдельный admin-эндпоинт).
   * @param orderId — id заказа
   */
  static async getAdminOrderById(orderId: number): Promise<IOrder | null> {
    const response = await $api.get(`/orders/admin/${orderId}`)
    const order = response?.data
    if (order?.id == null) {
      return null
    }
    return order
  }

  //редактируем заказ
  static async editOrder(data: any): Promise<{ data: IOrder }> {
    return $api.put('/orders/', data)
  }
  //получаем все статусы заказов
  static async getAllOrderStatus(): Promise<{ data: IOrderStatus[] }> {
    return $api.get('/order_status/')
  }
  //Создаём статус заказа
  static async createOrderStatus(
    data: IOrderStatus
  ): Promise<{ data: IOrderStatus }> {
    return $api.post('/order_status/', data)
  }
  //Редактируем статус заказа
  static async editOrderStatus(
    data: IOrderStatus
  ): Promise<{ data: IOrderStatus }> {
    return $api.put('/order_status/', data)
  }
  //удаляем статус заказа
  static async deleteOrderStatus(
    id: number | string
  ): Promise<{ data: IOrderStatus }> {
    return $api.delete(`/order_status/${id}`)
  }
}
